import { useTheme } from '@mui/material'
import React from 'react'

import { IconProps } from '@f-fertighaus/applications/Next/types/icon'

export const HeartIcon = (props: IconProps) => {
  const theme = useTheme()
  const stroke = props.color || theme.palette.primary.main
  return (
    <svg
      width='26'
      height='22'
      viewBox='0 0 26 22'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M22.4918 3.00777C20.1488 0.664773 16.3493 0.664773 14.0063 3.00777C13.5863 3.42777 13.2698 3.90477 12.9998 4.40127C12.7298 3.90477 12.4133 3.42627 11.9918 3.00627C9.64877 0.663273 5.84927 0.663273 3.50627 3.00627C1.16327 5.34927 1.16327 9.14877 3.50627 11.4918L12.9998 20.7498L22.4918 11.4918C24.8363 9.14877 24.8363 5.35077 22.4918 3.00777Z'
        stroke={stroke}
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}
